// Generated i18n file
export default {
  title: 'Tokyo Metro & Toei Subway Common 1-Day Ticket',
  notes: {
    item1:
      'Multiple tickets purchased simultaneously can be distributed to each smartphone via SNS or similar before starting use.',
    item2:
      'If using multiple QR codes on one device, the person holding the voucher must pass through last.',
    description2:
      '※It may take longer to pass through the ticket gate than usual, and you may not be able to board your intended train, so please allow extra time.',
    item3:
      'This ticket cannot be used to ride on lines other than Tokyo Metro and Toei Subway.',
    item4: 'Printed QR codes or screenshots cannot be used.',
    description4:
      '※If the validity of this ticket cannot be confirmed on the screen due to loss or battery depletion of your smartphone or device, you will be required to pay the regular fare for the section traveled, including the valid area of this ticket. Stations cannot provide charging facilities, so please be aware in advance.',
    item5:
      'The ticket cannot be used after its validity period or expiration. (Even if you press the "Start Use" button, if you do not use the ticket at the gate by the last train on that day, it will become invalid.)',
    item6:
      'Refunds are only available within the validity period and before starting use through the purchase history page, with a refund fee of 220 yen per transaction.',
    item7:
      'With a valid ticket displayed, you are eligible for substitute transportation.',
    item8:
      'If you have any questions about using the QR ticket, please contact the point of purchase with your "Reservation Number" and "Name".',
    description8: 'QR Code is a registered trademark of DENSO WAVE INC.',
    title: 'Important Notes'
  },
  explain: {
    description:
      'On the day of use, unlimited rides on all 9 Tokyo Metro lines and all 4 Toei Subway lines from first train to last train.',
    title: 'How to Use',
    area: 'Valid Area',
    areaValue: 'All Tokyo Metro lines and all Toei Subway lines',
    howToUse: 'How to Use',
    step1: {
      alt: 'Purchase QR Digital Ticket',
      description:
        '① The QR ticket is a service that allows you to purchase a QR digital ticket in advance on your smartphone and use it by scanning the QR code at the ticket gate.'
    },
    step2: {
      alt: 'Press Start Use button',
      description:
        '② You can enter and exit through ticket gates that support QR codes.',
      tip: '※At gates that do not support QR codes, please contact the station staff at the gate. If no staff are present, please use the intercom at the gate to call a station attendant.'
    },
    step3: {
      alt: 'Enter and exit at QR-compatible gates',
      description:
        '③ Before use, be sure to press the "Start Use" button to complete the entry process. Once you press the "Start Use" button, the validity period begins and refunds will no longer be possible. Please make sure to press the button just before use.'
    },
    validityDescription:
      'Valid until the last train on the day you press the “Start Use” button, on any one day within 90 days after purchase.',
    validityNotice:
      '※If the ticket is not used by the last train on the day the “Start Use” button is pressed, it will become invalid.',
    validityTitle: 'Validity Period / Expiration'
  },
  faq: {
    title: 'Frequently Asked Questions',
    faqList: [
      {
        answer: `This is a convenient ticket that can be purchased and used cashlessly with just a smartphone.
The QR code and animation displayed on your smartphone serve as your ticket.
The following ticket types are available:
・Tokyo Subway 24/48/72-Hour Ticket (QR)
・Tokyo Metro & Toei Subway Common 1-Day Pass (QR)
・Tokyo Metro 24-Hour Ticket (QR)
`,
        question: 'What are QR planned tickets?'
      },
      {
        answer: `Log in to the dedicated website using your "Google" or "Email" account, select the type of digital ticket, and pay by credit card.
※Please enter your name in half-width Roman letters.`,
        question: 'How can I purchase?'
      },
      {
        answer: 'VISA, MasterCard, JCB, American Express, Diners',
        question: 'Which credit cards can be used for payment?'
      },
      {
        answer: `3D Secure is required by the credit card issuer.
Including setup, if payment still cannot be completed, please contact your credit card company.`,
        question: 'What should I do if credit card payment cannot be used?'
      },
      {
        answer: `QR planned tickets cannot be used without a smartphone or similar device. Screenshots cannot be used either.`,
        question: 'Can I use QR planned tickets without a smartphone?'
      },
      {
        answer: `[Age Categories]
・Adult (12 years and older)
  Adult fare. However, elementary school students under 13 years old are charged the child fare.
・Child (6–11 years old)
  Child fare. However, children aged 6 who have not yet entered elementary school are treated as infants.
`,
        question: 'What are the age categories for tickets?'
      },
      {
        answer: `When a representative purchases multiple QR planned tickets for multiple people, if multiple tickets are purchased simultaneously, please distribute them to each smartphone via SNS or similar before starting use. If multiple tickets are used on one device without distribution, it may take extra time to pass through the gate and you may miss your intended train. Please allow extra time when using this method.
If using multiple QR planned tickets on one device, the person holding the voucher must pass through the ticket gate last.
`,
        question: 'What is the ticket distribution function?'
      },
      {
        answer:
          'On the date of ticket use (travel date), if you press the "Start Use" button and do not use the ticket at the gate by the last train of that day, the ticket will become invalid. Be sure to press the "Start Use" button on the day of travel, no earlier than the first train. The digital ticket validity period starts when you first pass through the ticket gate.',
        question: 'What does "Start Use" mean on the ticket screen?'
      },
      {
        answer:
          'At some stations, there are gates without ticket machines that support QR planned tickets. Please contact the station staff at the gate. Processing at station equipment is required when boarding or alighting. For gates without station staff, please use the intercom to call a station attendant. If the station office is far away, it may take time for staff to arrive, so please allow extra time.',
        question: 'What if there are no gates that support QR planned tickets?'
      },
      {
        answer: `Refunds are only available on the sales website for tickets within the validity period and before starting use. (Refund fee: 220 yen per transaction)
If you purchased multiple QR planned tickets and request a refund, partial refunds are not possible; all tickets will be refunded together, so please be aware.`,
        question: 'Can I get a refund?'
      },
      {
        answer: `If your smartphone or device is lost, or if the battery runs out and station staff cannot confirm your QR planned ticket screen, it will be treated as if you do not have a valid ticket, and you will need to pay the regular fare in cash or with an IC card for the section traveled. Please take care of your device's battery. Please note that stations cannot provide charging facilities.`,
        question:
          'What should I do if my smartphone malfunctions or runs out of battery while using the ticket?'
      },
      {
        answer:
          'Yes. If you can present a valid ticket, you are eligible for substitute transportation.',
        question: 'Is this ticket eligible for substitute transportation?'
      },
      {
        answer: `Please contact us by email.
Email address: helpcenter@linktivity.co.jp
`,
        question:
          "What should I do if I don't receive the confirmation email after purchase?"
      },
      {
        answer:
          'If you have any questions about using your QR planned ticket after purchase or after starting use, please contact the point of purchase with your "Reservation Number" and "Name".',
        question: 'What should I do if my QR planned ticket cannot be used?'
      }
    ]
  },
  ticket: {
    buy: 'Purchase',
    qrcode: {
      desc: 'Use with QR Code',
      title: 'Tokyo Metro & Toei Subway Common 1-Day Ticket'
    },
    ticketLink: {
      qrcode:
        'https://tokyometrods.triplabo.com/en/product/prod_agptukaojvyvpju53rrbt4kqqe?utm_source=metro-toei-pass.triplabo.jp&utm_medium=referral&utm_campaign=v3_migration&utm_content=metro_toei_pass_all_languages'
    }
  }
};
